import { Injectable } from "@angular/core";
import { BaseController } from "../../../core/controllers/base.controller";
import { FormStateService } from "./form-state.service";
import { FormEventsService } from "./form-events.service";
import { GroupInlined } from "../../business-objects/group/group.model";
import { CONTROL_TYPES } from "../../controls/control-types";
import { FieldWrapperComponent } from "../../modules-shared/field-wrapper/field-wrapper.component";
import { FieldWrapperKeyboardTabEvent } from "../../modules-shared/field-wrapper/events/field-wrapper-keyboard-tab-event";
import { Platform } from "ionic-angular";

@Injectable()
export class FormFocusController extends BaseController {

    protected group: GroupInlined;
    protected fieldWrappers: Array<FieldWrapperComponent> = [];
    protected autoFocusTimeout: any;

    constructor(
        protected stateService: FormStateService,
        protected eventsService: FormEventsService,
        protected platformService: Platform) {
        super();

        this.stateService.activeGroup$
            .takeUntil(this.ngUnsubscribe)
            .subscribe(group => this.group = group);

        this.eventsService.ionSlideDidChange
            .takeUntil(this.ngUnsubscribe)
            .subscribe(() => {

                if (this.platformService.is("mobile")) {
                    return;
                }

                clearTimeout(this.autoFocusTimeout);
                this.autoFocusTimeout = setTimeout(() => {
                    this.focusFirstGroupInput();
                }, 100);
            });
    }

    setFieldWrappers(fieldWrappers: Array<FieldWrapperComponent>): void {
        this.fieldWrappers = fieldWrappers;
    }

    handleFieldWrapperExitBackwards(event: FieldWrapperKeyboardTabEvent): void {
        try {
            if (event.fieldWrapper === this.getVisibleFieldWrappersByGroup().shift()) {
                event.$event.preventDefault();
                event.$event.stopPropagation();
                this.eventsService.exitGroupBackwards.next();
            }
        } catch (e) {
            console.warn(e);
        }
    }

    handleFieldWrapperExitForwards(event: FieldWrapperKeyboardTabEvent): void {
        try {
            if (event.fieldWrapper === this.getVisibleFieldWrappersByGroup().pop()) {
                event.$event.preventDefault();
                event.$event.stopPropagation();
                this.eventsService.exitGroupForwards.next();
            }
        } catch (e) {
            console.warn(e);
        }
    }

    handleTabOnForm($event: KeyboardEvent, shift: boolean = false): boolean {

        try {
            if (!this.fieldWrappers || !this.group) {
                return;
            }

            const wrapperElement = this.closest($event.target as any, "field-wrapper");

            if (!wrapperElement) {
                return;
            }

            const groupFieldWrappers = this.group.controls
                .filter(c => c.controlType.name !== CONTROL_TYPES.HIDDEN)
                .sort((a, b) => a.sequence - b.sequence)
                .map(control => this.fieldWrappers.find(w => w.definition.id === control.id));

            // if the wrapperElement is not in our group?
            if (!groupFieldWrappers.find(w => w.getNativeElement() === wrapperElement)) {
                console.log("tab detected outside of active group");
                this.focusFirstGroupInput();
                $event.preventDefault();
                $event.stopPropagation();
                return false;
            }
        } catch (e) {
            console.warn(e);
        }
    }

    focusFirstGroupInput(): void {
        try {
            this.getVisibleFieldWrappersByGroup().shift().focus();
        } catch (e) {
            console.warn(e);
        }
    }

    protected getVisibleFieldWrappersByGroup(): Array<FieldWrapperComponent> {

        if (!this.group || !this.fieldWrappers) {
            return [];
        }

        return (this.fieldWrappers || [])
            .filter(fw => fw.definition.controlType.name !== CONTROL_TYPES.HIDDEN && fw.definition.group === this.group.id)
            .sort((a, b) => a.definition.sequence - b.definition.sequence);
    }

    protected closest(elem: HTMLElement, selector: string): HTMLElement {

        if (elem.matches(selector)) {
            return elem;
        } else if (elem.parentElement) {
            return this.closest(elem.parentElement, selector);
        } else {
            return undefined;
        }
    }
}



// WEBPACK FOOTER //
// ./src/vas/pages/form/form-focus.controller.ts